import Component from '../abstracts/Component';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tab';


export default class CollapseComponent extends Component {
  get SELECTORS() {
    return {
      collapse: '[data-collapse]',
      tabs: '[data-tabs]'
    };
  }

  get CLASSES() {
    return {
      show: 'show'
    };
  }

  constructor() {
    super();
  }

  initCollapse() {
    let elements = document.querySelectorAll(this.SELECTORS.collapse);
    for(let el of elements){
        $(el).collapse();
    }
  }
  initTabs() {
    let elements = document.querySelectorAll(this.SELECTORS.collapse);
    for(let el of elements){
        $(el).tab();
    }
  }

  render() {
    this.log('Rendering...');
    if (document.querySelectorAll(this.SELECTORS.collapse)) {
      this.initCollapse();
    }
    if (document.querySelectorAll(this.SELECTORS.tabs)) {
      this.initTabs();
    }
  }
}
